import { ChangeDetectionStrategy, Component, HostListener, OnInit, Renderer2 } from '@angular/core'
import { Router } from '@angular/router'

import { PurchasesPopupService } from '../../../services/purchases-popup.service'
import { PurchasedErrorType } from '../../../types/purchased-track.type'

@Component({
  selector: 'bmcore-purchases-popup',
  templateUrl: './bmcore-purchases-popup.component.html',
  styleUrls: ['./bmcore-purchases-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePurchasesPopupComponent implements OnInit {
  isPopupOpen = false
  error: PurchasedErrorType

  constructor(
    private purchasesPopupService: PurchasesPopupService,
    private router: Router,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.purchasesPopupService.$showPurchasesPopupSubj.subscribe((error: PurchasedErrorType) => {
      // No parent scroll on modal scroll
      this.renderer.addClass(document.body, 'modal-open')

      this.isPopupOpen = true
      this.error = error
    })
  }

  redirectToBeatmaker() {
    this.closePopup()
    this.router.navigate([`/bm/${this.error.track.beatmakerId}`])
  }

  closePopup() {
    this.renderer.removeClass(document.body, 'modal-open')
    this.isPopupOpen = false
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closePopup()
    }
  }

  getMessage() {
    switch (this.error.reason) {
      case 'files':
        return `No files uploaded. Please contact ${this.error.track.beatmakerName}`
      case 'license':
        return `The “${this.error.track.beatName}” license is not available, please contact ${this.error.track.beatmakerName}.`
    }
  }
}
